import axios from 'axios';

const state = {
    datasourceGridMedication: {
        schema: {
            model: {
                id: "medicationPrescriptionID",
                fields: {
                    medicationPrescriptionID: {
                        editable: false,
                        nullable: true,
                    },
                },
            },
        },
        data: [
            {
                medicationPrescriptionID: 1,
                UserDisplayName: "Cataflam 50 gm strip1 hjkljlkj lkjklj kjklj lkjl hjghj ghfgh hgfhgf ",
                patientName: "Muhammad Ali Husein1 jhgjgj hjgjhgjghjh jhgjghjghjg",
                discriptionMedication: {
                    Name: 'Routine1',
                    BoxNumber: '1.00',
                    Hours: '8.00',
                    Weeks: '1.00'
                },
                unitOfMeasure: '15 (2 strip)',
                dateOfMedication: '13-06-2018'

            },
            {
                medicationPrescriptionID: 2,
                UserDisplayName: "Cataflam 50 gm strip2",
                patientName: "Muhammad Ali Husein2",
                discriptionMedication: {
                    Name: 'Routine2',
                    BoxNumber: '1.00',
                    Hours: '8.00',
                    Weeks: '1.00'
                },
                unitOfMeasure: '15 (2 strip)',
                dateOfMedication: '13-06-2018'

            },
            {
                medicationPrescriptionID: 3,
                UserDisplayName: "Cataflam 50 gm strip3",
                patientName: "Muhammad Ali Husein3",
                discriptionMedication: {
                    Name: 'Routine3',
                    BoxNumber: '1.00',
                    Hours: '8.00',
                    Weeks: '1.00'
                },
                unitOfMeasure: '15 (2 strip)',
                dateOfMedication: '13-06-2018'

            },
            {
                medicationPrescriptionID: 4,
                UserDisplayName: "Cataflam 50 gm strip4",
                patientName: "Muhammad Ali Husein4",
                discriptionMedication: {
                    Name: 'Routine4',
                    BoxNumber: '1.00',
                    Hours: '8.00',
                    Weeks: '1.00'
                },
                unitOfMeasure: '15 (2 strip)',
                dateOfMedication: '13-06-2018'
            },
           
        ],
    },
    dimmedCreateVisit: false
};

// Get data
const getters = {
    datasourceGridMedication(state) {
        return state.datasourceGridMedication;
    },
    dimmedCreateVisit(state) {
        return state.dimmedCreateVisit;
    },
};


// Update Data "mutations"
const mutations = {
    save_datasourceGridMedication(state, datasourceGridMedication) {
        state.datasourceGridMedication = datasourceGridMedication;
    },
    dimmedCreateVisit: (state, flag) => { state.dimmedCreateVisit = flag }
};

const actions = {
    load_datasourceGridMedication(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_datasourceGridMedication', result.data);
            });
    },
};

export default {
    mutations,
    actions,
    state,
    getters
};
